<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      dark
      elevation="0"
      :hide-on-scroll="false"
      :scroll-off-screen="false"
      :extended="extend"

      :height="alturaMenu"
    >
      <v-container fluid>
        <v-row :style="'max-height:'+alturaMenu+'px; overflow: hidden;'">
          <v-col cols="6" sm="2" md="4">
            <router-link to="/">
              <v-img
                src="@/assets/img/neutralnetworks_logo.svg"
                style="z-index: 20"
                class="header--logo"
              ></v-img>
            </router-link>
          </v-col>
          <v-col cols="6" sm="10" md="8" class="text-right">
            <template v-if="locale == 'en'">
              <v-row align="center">
                <v-col>
                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                      >
                        Products
                      </v-btn>
                    </template>

                    <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="metro-bg px-6">
                          <router-link to="/productos/metro" class="d-block">
                            <v-img src="@/assets/img/logo-metro-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="link-bg px-6">
                          <router-link to="/productos/link" class="d-block">
                            <v-img src="@/assets/img/logo-link-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="next-bg px-6">
                          <router-link to="/productos/next" class="d-block">
                            <v-img src="@/assets/img/logo-next-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="neutral-towers-bg px-6">
                          <router-link to="/duenos-y-arrendadores" class="d-block">
                            <v-img src="@/assets/img/neutral-towers-logo.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <router-link to="/productos"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >PRODUCTOS</span
                    >
                  </router-link> -->
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/acerca-de"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    ACERCA DE
                  </v-btn> -->

                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                        to="/acerca-de"
                      >
                        <!-- <span class="pt-2">ACERCA DE</span> -->
                        <span class="pt-2">ABOUT US</span>
                        
                      </v-btn>
                    </template>

                    <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/acerca-de" style="color: #5C27B2; text-decoration: none">About us</router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/NuestraDiferencia" style="color: #5C27B2; text-decoration: none">Why Neutral Networks?</router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                        to="/contacto"
                      >
                        <span class="pt-2">Contact</span>
                        
                      </v-btn>
                    </template>

                    <!-- <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/duenos-y-arrendadores" style="color: #5C27B2; text-decoration: none">
                          Dueños de Activos y Arrendadores
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list> -->
                  </v-menu>
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/contacto"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    CONTACTO
                  </v-btn> -->
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/NuestraDiferencia"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    ¿POR QUÉ NEUTRAL NETWORKS?
                  </v-btn> -->
                  <v-btn
                    text
                    color="#48306e"
                    to="/academy"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    NEUTRAL PARTNERS
                  </v-btn>
                  <v-btn
                    text
                    color="#48306e"
                    to="/blog"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    BLOG
                  </v-btn>


                  <v-btn class="d-none d-md-inline-flex" text dark color="#48306e" @click="$i18n.locale = 'es'" small>Es</v-btn>
                  <v-btn class="d-none d-md-inline-flex" text color="#48306e" :disabled="locale == 'en'" @click="$i18n.locale = 'en'" small>En</v-btn>

                  <v-btn text dark color="#48306e" @click="$i18n.locale = 'es'" small class="d-md-none">Es</v-btn>
                  <!-- <v-btn text color="#48306e" :disabled="locale == 'en'" @click="$i18n.locale = 'en'" small>EEn</v-btn> -->
                  
                  <!-- <router-link to="/productos"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >NEUTRAL NETWORKS ACADEMY</span
                    >
                  </router-link>
                  <router-link to="/acerca-de"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >BLOG</span
                    >
                  </router-link> -->
                </v-col>
                <v-col cols="auto">
                  <v-btn icon>

                    <v-icon
                      class="d-sm-none"
                      color="#48306E"
                      size="32"
                      style="z-index: 20"
                      @click="isOpen = !isOpen"
                      >mdi-menu</v-icon
                    >
                  </v-btn>
                </v-col>
              </v-row>
            </template>
            <template v-else>
              <v-row align="center">
                <v-col>
                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                      >
                        Productos
                      </v-btn>
                    </template>

                    <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="metro-bg px-6">
                          <router-link to="/productos/metro" class="d-block">
                            <v-img src="@/assets/img/logo-metro-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="link-bg px-6">
                          <router-link to="/productos/link" class="d-block">
                            <v-img src="@/assets/img/logo-link-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="next-bg px-6">
                          <router-link to="/productos/next" class="d-block">
                            <v-img src="@/assets/img/logo-next-blanco.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="neutral-towers-bg px-6">
                          <router-link to="/duenos-y-arrendadores" class="d-block">
                            <v-img src="@/assets/img/neutral-towers-logo.png" height="50px" width="200px" contain position="center center"></v-img>
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <!-- <router-link to="/productos"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >PRODUCTOS</span
                    >
                  </router-link> -->
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/acerca-de"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    ACERCA DE
                  </v-btn> -->

                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                        to="/acerca-de"
                      >
                        <!-- <span class="pt-2">ACERCA DE</span> -->
                        <span class="pt-2">NOSOTROS</span>
                        
                      </v-btn>
                    </template>

                    <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/acerca-de" style="color: #5C27B2; text-decoration: none">Acerca de</router-link>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/NuestraDiferencia" style="color: #5C27B2; text-decoration: none">¿Por qué Neutral Networks?</router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>
                  <v-menu
                    open-on-hover
                    bottom
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        text
                        color="#48306e"
                        class="d-none d-md-inline-block"
                        :ripple="false"
                        to="/contacto"
                      >
                        <span class="pt-2">Contacto</span>
                        
                      </v-btn>
                    </template>

                    <!-- <v-list class="py-0">
                      <v-list-item class="px-0">
                        <v-list-item-title class="px-6">
                          <router-link to="/duenos-y-arrendadores" style="color: #5C27B2; text-decoration: none">
                          Dueños de Activos y Arrendadores
                          </router-link>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list> -->
                  </v-menu>
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/contacto"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    CONTACTO
                  </v-btn> -->
                  <!-- <v-btn
                    text
                    color="#48306e"
                    to="/NuestraDiferencia"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    ¿POR QUÉ NEUTRAL NETWORKS?
                  </v-btn> -->
                  <v-btn
                    text
                    color="#48306e"
                    to="/academy"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    NEUTRAL PARTNERS
                  </v-btn>
                  <v-btn
                    text
                    color="#48306e"
                    to="/blog"
                    class="d-none d-md-inline-block pt-2"
                    :ripple="false"
                  >
                    BLOG
                  </v-btn>


                  <v-btn class="d-none d-md-inline-flex" text dark color="#48306e" :disabled="locale != 'en'" @click="$i18n.locale = 'es'" small>Es</v-btn>
                  <v-btn class="d-none d-md-inline-flex" text color="#48306e" @click="$i18n.locale = 'en'" small>En</v-btn>


                  <v-btn text color="#48306e" @click="$i18n.locale = 'en'" small class="d-md-none">En</v-btn>
                  
                  <!-- <router-link to="/productos"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >NEUTRAL NETWORKS ACADEMY</span
                    >
                  </router-link>
                  <router-link to="/acerca-de"
                    ><span
                      class="single-item-size px-sm-3 d-none d-sm-inline-block"
                      style="color: #48306e"
                      >BLOG</span
                    >
                  </router-link> -->
                </v-col>
                <v-col cols="auto">
                  <v-btn icon>

                    <v-icon
                      class="d-sm-none"
                      color="#48306E"
                      size="32"
                      style="z-index: 20"
                      @click="isOpen = !isOpen"
                      >mdi-menu</v-icon
                    >
                  </v-btn>
                </v-col>
              </v-row>
              <!-- <router-link to="/por-que-neutralNetwors"
                ><span
                  class="single-item-size px-sm-3 d-none d-sm-inline-block"
                  style="color: #48306e"
                  >¿POR QUÉ NEUTRAL NETWORKS?</span
                ></router-link
              > -->
            </template>

            <div
              id="menu"
              v-bind:class="{ open: isOpen }"
              class="d-none d-sm-block"
            >
              <v-container fluid class="py-0">
                <v-row class="color-morado">
                  <v-col
                    cols="5"
                    sm="5"
                    md="5"
                    lg="5"
                    class="pa-0 d-none d-md-block"
                  >
                    <template v-for="(item, ser) in servicios">
                      <v-img
                        :key="'servicio-' + ser"
                        :src="
                          'https://nncms.actstudio.xyz' + item.imagenCover.path
                        "
                        width="100%"
                        height="calc(100vh - 100px)"
                        v-show="categoriaActiva == ser"
                        class="align-items-start align-center text-center"
                        :contain="false"
                      >
                        <div
                          class="d-flex"
                          style="
                            background-color: rgba(92, 39, 178, 0.65);
                            height: calc(100vh - 100px);
                          "
                        >
                          <v-row justify="center" align="center">
                            <v-col class="text-center" cols="9" md="9" lg="9">
                              <div style="">
                                <span class="enfasis-size bold d-block mb-4">{{
                                  item.name
                                }}</span>
                                <span class="titulos-size bold d-block">{{
                                  item.subtitle
                                }}</span>
                              </div>
                            </v-col>
                          </v-row>
                        </div>
                      </v-img>
                    </template>
                  </v-col>
                  <v-col
                    cols="12"
                    sm="12"
                    md="6"
                    lg="6"
                    class="text-start"
                    style="color: #48306e"
                  >
                    <v-row justify="start" justify-sm="end" justify-md="center">
                      <v-col cols="5" sm="6" md="5" class="pl-sm-16 py-sm-13">
                        <template v-if="locale == 'en'">
                          <span class="titulos-size bold d-block mb-md-4"
                            >Products</span
                          >
                        </template>
                        <template v-else>
                          <span class="titulos-size bold d-block mb-md-4"
                            >Productos</span
                          >
                        </template>

                        <router-link
                          :to="'/servicios/' + servicio.url"
                          v-for="(servicio, s) in servicios"
                          class="single-item-size d-block my-1"
                          @mouseover.native="categoriaActiva = s"
                          @mouseout.native="categoriaActiva = null"
                          :key="s"
                          v-bind:class="{ bold: categoriaActiva == s }"
                          style="color: #48306e"
                          >{{ servicio.name }}
                        </router-link>

                        <template v-if="locale == 'en'">
                          <span class="titulos-size bold d-block mt-4 mb-2"
                            >Us</span
                          >
                        </template>
                        <template v-else>
                          <span class="titulos-size bold d-block mt-4 mb-2"
                            >Nosotros</span
                          >
                        </template>

                        <template v-if="locale == 'en'">
                          <router-link to="/">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Home</span
                            ></router-link
                          >
                          <router-link to="/acerca-de">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >About us
                            </span></router-link
                          >
                          <router-link to="/NuestraDiferencia">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Why Neutral Networks?</span
                            >
                          </router-link>
                          <router-link to="/academy">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Neutral Partners</span
                            ></router-link
                          >
                          <router-link to="/blog">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >News</span
                            ></router-link
                          >
                          <router-link to="/contacto">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Contact</span
                            >
                          </router-link>
                        </template>
                        <template v-else>
                          <router-link to="/">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Inicio</span
                            ></router-link
                          >
                          <router-link to="/acerca-de">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Acerca de
                            </span></router-link
                          >
                          <router-link to="/NuestraDiferencia">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >¿Por qué Neutral Networks?</span
                            >
                          </router-link>
                          <router-link to="/academy">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Neutral Partners</span
                            ></router-link
                          >
                          <router-link to="/blog">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Noticias</span
                            ></router-link
                          >
                          <router-link to="/contacto">
                            <span
                              class="
                                single-item-size
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              style="color: #48306e"
                              >Contacto</span
                            >
                          </router-link>
                        </template>
                      </v-col>
                      <v-col cols="12" sm="6" md="6" lg="6" class="py-sm-13">
                        <!-- <template v-if="locale == 'en'">
                            <span class="titulos-size bold d-block mb-md-4 mb-lg-6">Call Center</span>
                          </template>
                          <template v-else>
                            <span class="titulos-size bold d-block mb-md-4 mb-lg-6">Líneas de atención</span>
                          </template>
                      
                          
                          
                          <v-img src="@/assets/img/telefonos-nn-1.svg" width="18" class="d-inline-block mr-2 mr-md-2 mr-lg-2" ></v-img> -->
                        <!-- <span class="single-item-size  d-inline-block mb-md-5 mb-lg-5">(81) 1969 6670</span> -->

                        <div class="d-block"></div>

                        <v-img
                          src="@/assets/img/mensaje.jpg"
                          width="18"
                          class="d-inline-block pr-1 pr-md-0 pr-lg-1"
                        ></v-img>
                        <span class="single-item-size d-inline-block mb-3 pl-1"
                          >comercial@neutralnetworks.mx</span
                        >

                        <template v-if="locale == 'en'">
                          <span class="single-item-size bold d-block"
                            >Address</span
                          >
                        </template>
                        <template v-else>
                          <span class="single-item-size bold d-block"
                            >Dirección</span
                          >
                        </template>

                        <span class="single-item-size bold d-block mt-3"
                          >Monterrey</span
                        >
                        <span class="single-item-size d-block"
                          >Avenida José Vasconcelos 345-Ote Piso 24</span
                        >
                        <span class="single-item-size d-block mb-3"
                          >Santa Engracia, 66267 San Pedro Garza García,
                          N.L.</span
                        >

                        <span class="single-item-size bold d-block"
                          >Ciudad de México</span
                        >
                        <span class="single-item-size d-block">
                          Insurgentes Sur 800, Col. Del Valle, Benito Juárez,
                          CDMX
                        </span>

                        <template v-if="locale == 'en'">
                          <span
                            class="single-item-size bold d-inline-block mr-2"
                            >Follow us:
                          </span>
                        </template>
                        <template v-else>
                          <span
                            class="single-item-size bold d-inline-block mr-2"
                            >Siguenos en:
                          </span>
                        </template>
                        <v-avatar>
                          <v-icon color="#5C27B2">mdi-linkedin</v-icon>
                        </v-avatar>

                        <template v-if="locale == 'en'">
                          <!-- <span class="single-item-size d-block mt-6 mb-4 bold"
                            >Request more info:
                          </span>
                          <router-link to="/duenos-y-arrendadores"
                            ><span
                              class="
                                single-item-size
                                color-morado
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              >Asset Owners and Landlords
                            </span>
                          </router-link> -->
                          <!-- <router-link to="/renta-servicios"
                            ><span
                              class="
                                single-item-size
                                color-morado
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              >Rental Services
                            </span></router-link
                          > -->
                        </template>
                        <template v-else>
                          <span class="single-item-size d-block mt-6 mb-4 bold"
                            >Solicita más información:
                          </span>
                          <router-link to="/duenos-y-arrendadores"
                            ><span
                              class="
                                single-item-size
                                color-morado
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              >Dueño de Activos y Arrendadores
                            </span>
                          </router-link>
                          <!-- <router-link to="/renta-servicios"
                            ><span
                              class="
                                single-item-size
                                color-morado
                                d-block
                                my-1 my-md-1 my-lg-1
                              "
                              >Renta de Servicios
                            </span></router-link
                          > -->
                        </template>
                      </v-col>

                      <v-col cols="11" class="pt-12">
                        <v-img
                          src="@/assets/img/an-evengroup-company_logo-morado.svg"
                          width="150"
                        ></v-img>
                        <template v-if="locale == 'en'">
                          <span class="small-size">
                            © Neutral Networks all rights reserved |
                            <router-link
                              class="color-morado"
                              to="/aviso-de-privacidad"
                            >
                              <span class="color-morado">
                                Notice of Privacy</span
                              ></router-link
                            >
                            |
                            <a
                              class="color-morado"
                              href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                              ><span class="color-morado">
                                Código de Prácticas Comerciales</span
                              >
                            </a>
                          </span>
                        </template>
                        <template v-else>
                          <span class="small-size">
                            © Neutral Networks todos los derechos reservados |
                            <router-link
                              class="color-morado"
                              to="/aviso-de-privacidad"
                            >
                              <span class="color-morado">
                                Aviso de privacidad</span
                              ></router-link
                            >
                            |
                            <a
                              class="color-morado"
                              href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                              ><span class="color-morado">
                                Código de Prácticas Comerciales</span
                              >
                            </a>
                          </span>
                        </template>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-app-bar>

    <v-main>
      <div v-bind:class="{ 'd-none': isOpen }" class="d-sm-block">
        <router-view> </router-view>
      </div>
      <div
        id="mobileAppBar"
        v-bind:class="{ open: isOpen, 'd-flex': isOpen }"
        class="d-none d-sm-none"
      >
        <v-container fluid class="py-0">
          <v-row class="color-morado">
            <v-col
              cols="12"
              sm="6"
              md="6"
              lg="6"
              class="text-start"
              style="color: #48306e"
            >
              <v-row justify="start" justify-sm="center ">
                <v-col cols="12" class="pl-8">
                  <template v-if="locale == 'en'">
                    <span class="titulos-size bold d-block mb-md-4">Products</span>
                  </template>
                  <template v-else>
                    <span class="titulos-size bold d-block mb-md-4">Productos</span>
                  </template>

                  <router-link to="/productos/metro" class="single-item-size d-block my-1" style="color: #48306e">Metro: fiber network</router-link>
                  <router-link to="/productos/link" class="single-item-size d-block my-1" style="color: #48306e">Link: hub connectivity</router-link>
                  <router-link to="/productos/next" class="single-item-size d-block my-1" style="color: #48306e">Next: fiber network</router-link>
                  <router-link to="/duenos-y-arrendadores" class="single-item-size d-block my-1" style="color: #48306e">Neutral Towers</router-link>

                  <!-- <router-link
                    :to="'/servicios/' + servicio.url"
                    v-for="(servicio, s) in servicios"
                    class="single-item-size d-block my-1"
                    @mouseover.native="categoriaActiva = s"
                    @mouseout.native="categoriaActiva = null"
                    :key="s"
                    v-bind:class="{ bold: categoriaActiva == s }"
                    style="color: #48306e"
                    >{{ servicio.name }}
                  </router-link> -->

                  <template v-if="locale == 'en'">
                    <span class="titulos-size bold d-block mt-4 mb-2">About us</span>

                    <router-link to="/">
                    <span
                      class="single-item-size d-block my-1 my-md-1 my-lg-1"
                      style="color: #48306e"
                      >Home</span
                    ></router-link
                    >
                    <router-link to="/acerca-de">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >About us
                      </span></router-link
                    >
                    <router-link to="/NuestraDiferencia">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Why Neutral Networks?</span
                      >
                    </router-link>
                    <router-link to="/academy">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Neutral Partners</span
                      ></router-link
                    >
                    <router-link to="/blog">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Blog</span
                      ></router-link
                    >
                    <router-link to="/contacto">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Contact</span
                      >
                    </router-link>
                  </template>
                  <template v-else>
                    <span class="titulos-size bold d-block mt-4 mb-2">Nosotros</span>


                    <router-link to="/">
                    <span
                      class="single-item-size d-block my-1 my-md-1 my-lg-1"
                      style="color: #48306e"
                      >Inicio</span
                    ></router-link
                    >
                    <router-link to="/acerca-de">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Acerca de
                      </span></router-link
                    >
                    <router-link to="/NuestraDiferencia">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >¿Por qué Neutral Networks?</span
                      >
                    </router-link>
                    <router-link to="/academy">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Neutral Partners</span
                      ></router-link
                    >
                    <router-link to="/blog">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Blog</span
                      ></router-link
                    >
                    <router-link to="/contacto">
                      <span
                        class="single-item-size d-block my-1 my-md-1 my-lg-1"
                        style="color: #48306e"
                        >Contacto</span
                      >
                    </router-link>
                  </template>

                </v-col>
                <v-col cols="12" class="pl-8">
                  <!-- <span class="titulos-size bold d-block  mb-4 mb-lg-6">Líneas de atención</span>
                      
                          <v-img src="@/assets/img/telefonos-nn-1.svg" width="18" class="d-inline-block mr-2 mr-md-2 mr-lg-2" ></v-img> -->
                  <!-- <span class="single-item-size  d-inline-block mb-md-5 mb-lg-5">(81) 1969 6670</span> -->

                  <div class="d-block"></div>

                  <v-img
                    src="@/assets/img/mensaje.jpg"
                    width="18"
                    class="d-inline-block pr-1"
                  ></v-img>
                  <span class="single-item-size d-inline-block mb-3 ml-1"
                    >comercial@neutralnetworks.mx</span
                  >

                  <span class="single-item-size bold d-block">
                    <template v-if="locale == 'en'">
                      Address
                    </template>
                    <template v-else>
                      Dirección
                    </template>
                  </span>
                  <span class="single-item-size d-block"
                    >Avenida José Vasconcelos 345-Ote Piso 24</span
                  >
                  <span class="single-item-size d-block mb-3"
                    >Santa Engracia, 66267 San Pedro Garza García, N.L.</span
                  >

                  <span class="single-item-size bold d-inline-block mr-2"
                    >
                    <template v-if="locale == 'en'">
                      Follow us
                    </template>
                    <template v-else>
                      Siguenos en:
                    </template>
                  </span>
                  <v-avatar>
                    <v-icon color="#5C27B2">mdi-linkedin</v-icon>
                  </v-avatar>

                  <!-- <span class="single-item-size d-block mt-6 mb-4 bold"
                    >Solicita más información:
                  </span>

                  <router-link to="/duenos-y-arrendadores"
                    ><span
                      class="
                        single-item-size
                        color-morado
                        d-block
                        my-1 my-md-1 my-lg-1
                      "
                      >Dueño de Activos y Arrendadores
                    </span>
                  </router-link> -->
                  <!-- <router-link to="/renta-servicios"
                    ><span
                      class="
                        single-item-size
                        color-morado
                        d-block
                        my-1 my-md-1 my-lg-1
                      "
                      >Renta de Servicios
                    </span></router-link
                  > -->
                </v-col>
              </v-row>

              <v-row justify="center">
                <v-col cols="11" class="pt-10 pt-md-0 text-center">
                  <v-img
                    src="@/assets/img/an-evengroup-company_logo-morado.svg"
                    width="173"
                    class="ml-16"
                  ></v-img>
                  <template v-if="locale == 'en'">
                    <span class="small-size">
                      © Neutral Networks all rights reserved |
                      <router-link
                        class="color-morado"
                        to="/aviso-de-privacidad"
                      >
                        <span class="color-morado">
                          Notice of Privacy</span
                        ></router-link
                      >
                      |
                      <a
                        class="color-morado"
                        href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                        ><span class="color-morado">
                          Código de Prácticas Comerciales</span
                        >
                      </a>
                    </span>
                  </template>
                  <template v-else>
                    <span class="small-size">
                      © Neutral Networks todos los derechos reservados |
                      <router-link
                        class="color-morado"
                        to="/aviso-de-privacidad"
                      >
                        <span class="color-morado">
                          Aviso de privacidad</span
                        ></router-link
                      >
                      |
                      <a
                        class="color-morado"
                        href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                        ><span class="color-morado">
                          Código de Prácticas Comerciales</span
                        >
                      </a>
                    </span>
                  </template>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-main>

    <v-footer dark color="#5C27B2" v-show="!isOpen">
      <v-container>
        <v-row class="my-6">
          <v-col>
            <v-img
              src="@/assets/img/neutralnetworks_blanco.svg"
              width="195"
            ></v-img>
          </v-col>
        </v-row>
        <v-row class="d-none d-md-flex">
          <v-col cols="3">
            <template v-if="locale == 'en'">
              <span class="montserrat bold titulos-size">Contact</span>
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size">Contacto</span>
            </template>
          </v-col>
          <v-col cols="3">
            <template v-if="locale == 'en'">
              <span class="montserrat bold titulos-size">Products</span>
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size">Productos</span>
            </template>
          </v-col>
          <v-col cols="3">
            <template v-if="locale == 'en'">
              <span class="montserrat bold titulos-size">Sections</span>
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size">Secciones</span>
            </template>
          </v-col>
        </v-row>

        <v-row class="mb-6">
          <v-col cols="12" md="3">
            <template v-if="locale == 'en'">
              <span class="montserrat bold titulos-size d-md-none"
                >Contact</span
              >
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size d-md-none"
                >Contacto</span
              >
            </template>
            <!-- <span class="d-block montserrat single-item-size">(81) 1969 6670</span> -->
            <span class="d-block montserrat single-item-size"
              >comercial@neutralnetworks.mx</span
            >

            <template v-if="locale == 'en'">
              <span class="d-block montserrat single-item-size mt-10"
                >Subscribe</span
              >
            </template>
            <template v-else>
              <span class="d-block montserrat single-item-size mt-10"
                >Suscribete a nuestro Newsletter</span
              >
            </template>
            <v-row class="mx-0">
              <v-col cols="12" sm="12" class="px-0">
                <template v-if="locale == 'en'">
                  <v-text-field
                    label="E-Mail"
                    outlined
                    dense
                    filled
                    :rounded="false"
                    :shaped="false"
                    append-outer-icon="mdi-check"
                    @click:append-outer="subscribeAction()"
                  ></v-text-field>
                </template>
                <template v-else>
                  <v-text-field
                    label="Correo Electrónico"
                    outlined
                    dense
                    filled
                    :rounded="false"
                    :shaped="false"
                    append-outer-icon="mdi-check"
                    @click:append-outer="subscribeAction()"
                  >
                  </v-text-field>
                </template>
              </v-col>
              <!-- <v-col cols="auto" sm="6" class="px-0">
                <v-btn width="30" height="40" color="#C3B0E2" tile>
                  <v-icon color="#5C27B2">mdi-check</v-icon>
                </v-btn>
              </v-col> -->
            </v-row>
          </v-col>
          <v-col cols="12" md="3">
            <template v-if="locale == 'en'">
              <span class="montserrat bold titulos-size d-md-none"
                >Products</span
              >
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size d-md-none"
                >Productos</span
              >
            </template>

            <!-- <router-link
              v-for="(servicio, s) in servicios"
              :key="'serv-link-' + s"
              :to="'/servicios/' + servicio.url"
              class="
                d-block
                medium
                color-blanco
                none-decoration
                single-item-size
                uppercase
              "
              >{{ servicio.name }}</router-link> -->

            <router-link to="/productos/metro" class="d-block white--text non-text-decoration single-item-size" style="">
              Metro: fiber network
              <!-- <v-img src="@/assets/img/logo-metro-blanco.png" height="50px" width="200px" contain position="left center"></v-img> -->
            </router-link>
            <router-link to="/productos/link" class="d-block white--text non-text-decoration single-item-size" style="">
              Link: hub connectivity
              <!-- <v-img src="@/assets/img/logo-link-blanco.png" height="50px" width="200px" contain position="left center"></v-img> -->
            </router-link>
            <router-link to="/productos/next" class="d-block white--text non-text-decoration single-item-size" style="">
              Next: fiber network
              <!-- <v-img src="@/assets/img/logo-next-blanco.png" height="50px" width="200px" contain position="left center"></v-img> -->
            </router-link>
            <router-link to="/duenos-y-arrendadores" class="d-block white--text non-text-decoration single-item-size" style="">
              Neutral Towers
              <!-- <v-img src="@/assets/img/logo-next-blanco.png" height="50px" width="200px" contain position="left center"></v-img> -->
            </router-link>
          </v-col>
          <v-col cols="12" md="3">
            <template v-if="locale == 'en'">
              
              <span class="montserrat bold titulos-size d-md-none"
                >Sections</span
              >
              <router-link
                to="/"
                class="d-block color-blanco none-decoration single-item-size"
                >Home</router-link
              >
              <br>
              <router-link
                to="/acerca-de"
                class="d-block color-blanco none-decoration single-item-size bold"
                >About us</router-link
              >
              <router-link
                to="/NuestraDiferencia"
                class="d-block color-blanco none-decoration single-item-size"
                >Why Neutral Networks?</router-link
              >
              <br>
              <router-link
                to="/academy"
                class="d-block color-blanco none-decoration single-item-size"
                >Neutral Partners</router-link
              >
              <router-link
                to="/blog"
                class="d-block color-blanco none-decoration single-item-size"
                >Blog</router-link
              >
            </template>
            <template v-else>
              <span class="montserrat bold titulos-size d-md-none"
                >Secciones</span
              >
              <router-link
                to="/"
                class="d-block color-blanco none-decoration single-item-size"
                >Inicio</router-link
              >
              <br>
              <router-link
                to="/acerca-de"
                class="d-block color-blanco none-decoration single-item-size bold"
                >Acerca de</router-link
              >
              <router-link
                to="/NuestraDiferencia"
                class="d-block color-blanco none-decoration single-item-size"
                >¿Por qué Neutral Networks?</router-link
              >
              <br>
              <router-link
                to="/academy"
                class="d-block color-blanco none-decoration single-item-size"
                >Neutral Partners</router-link
              >
              <router-link
                to="/blog"
                class="d-block color-blanco none-decoration single-item-size"
                >Blog</router-link
              >
            </template>
          </v-col>
          <v-col cols="6" md="3">
            <template v-if="locale == 'en'">
              <router-link
                to="/"
                class="
                  d-block
                  color-blanco
                  none-decoration
                  single-item-size
                  bold
                "
                >Request more info</router-link
              >
              <!-- <router-link
                to="/renta-servicios"
                class="d-block color-blanco none-decoration single-item-size"
                >Rental Services</router-link
              > -->
              <!-- <router-link
                to="/duenos-y-arrendadores"
                class="d-block color-blanco none-decoration single-item-size"
                >Asset Owners and Landlords</router-link
              > -->

              <v-btn icon target="_blank" color="white" href="https://www.facebook.com/Neutral-Networks-107188574220774">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon target="_blank" color="white" href="https://www.linkedin.com/company/neutralnetworks/">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn icon target="_blank" color="white" href="https://twitter.com/NeutralNetworks">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
            </template>
            <template v-else>
              <router-link
                to="/contacto"
                class="
                  d-block
                  color-blanco
                  none-decoration
                  single-item-size
                  bold
                "
                >Contacto</router-link
              >
              <!-- <router-link
                to="/renta-servicios"
                class="d-block color-blanco none-decoration single-item-size"
                >Renta de Servicios</router-link
              > -->
              <!-- <router-link
                to="/duenos-y-arrendadores"
                class="d-block color-blanco none-decoration single-item-size"
                >Dueños de Activos y Arrendadores</router-link
              > -->
              <v-btn icon target="_blank" color="white" href="https://www.facebook.com/Neutral-Networks-107188574220774">
                <v-icon>mdi-facebook</v-icon>
              </v-btn>
              <v-btn icon target="_blank" color="white" href="https://www.linkedin.com/company/neutralnetworks/">
                <v-icon>mdi-linkedin</v-icon>
              </v-btn>
              <v-btn icon target="_blank" color="white" href="https://twitter.com/NeutralNetworks">
                <v-icon>mdi-twitter</v-icon>
              </v-btn>
            </template>
          </v-col>
        </v-row>

        <v-row align="center">
          <v-col cols="auto">
            <v-img
              src="@/assets/an-evengroup-company_logo-blanco.svg"
              width="182"
            ></v-img>
          </v-col>
          <v-col cols="12">
            <span class="small-size">
              <template v-if="locale == 'en'">
                © Neutral Networks all rights reserved |
                <router-link class="color-blanco" to="/aviso-de-privacidad"
                  >Notice of Privacy</router-link
                >
                |
                <a
                  class="color-blanco"
                  href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                  >Código de Prácticas Comerciales</a
                >
              </template>
              <template v-else>
                © Neutral Networks todos los derechos reservados |
                <router-link class="color-blanco" to="/aviso-de-privacidad"
                  >Aviso de privacidad</router-link
                >
                |
                <a
                  class="color-blanco"
                  href="/files/pdf/codigo-de-practicas-comerciales-de-neutral-networks.pdf"
                  >Código de Prácticas Comerciales</a
                >
              </template>
            </span>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>

    <div class="bottom-consent" v-bind:class="{'open':cookieConsent && showCookieConsent}">

      <v-container fluid class="my-0 py-4">
        <v-row no-gutters align="center">
          <v-col cols="10" offset="1" class="text-center">
            <span class="white--text">Esta página web usa cookies</span>
          </v-col>
          <v-col cols="1" class="text-right">
            <v-btn color="white" icon @click="cookieConsent = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-col>
        </v-row>
        <v-row no-gutters class="my-0">
          <v-col>
            <v-container class="my-0 py-0">
              <v-row no-gutters class="my-0" justify="center">
                <v-col class="my-0" style="max-width: 800px">
                  <p class="white--text mt-3 mb-3" style="font-size: 14px">Las cookies de este sitio web se usan para personalizar el contenido y los anuncios, ofrecer funciones de redes sociales y analizar el tráfico. Además, compartimos información sobre el uso que haga del sitio web con nuestros partners de redes sociales, publicidad y análisis web, quienes pueden combinarla con otra información que les haya proporcionado o que hayan recopilado a partir del uso que haya hecho de sus servicios.</p>
                </v-col>
              </v-row>
            </v-container>
          </v-col>
        </v-row>
        <v-row class="my-0 py-0 mt-md-3" justify="center">
          <v-col cols="12" class="text-center">
            <v-btn  elevation="0" tile width="219px" @click="cookieConsent = false; registrarCookie()"> 
              <span class="continuos-texts" style="text-transform: none; color: #5C27B2">Acepto</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import Vue from 'vue'
import VueSession from 'vue-session'
Vue.use(VueSession,{persist:true})

export default {
  name: "App",

  components: {},

  data: () => ({
    cookieConsent: false,
    isOpen: false,
    categoriaActiva: 0,
    servicios: {},
    scroll: 0,
    extend: false,
    aviso: {
      Pdf: {
        path: "",
      },
    },
    alturaMenu: 56
  }),
  mounted: function () {



    if (this.locale == "en") {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/AvisoPrivacidad?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: { activo: true },
            sort: { _o: 1 },
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.aviso = data));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: { activo: true },
            sort: { _o: 1 },
            lang: "en", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.servicios = res.entries));
    } else {
      fetch(
        "https://nncms.actstudio.xyz/api/singletons/get/AvisoPrivacidad?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: { activo: true },
            sort: { _o: 1 },
            lang: "de", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((data) => data.json())
        .then((data) => (this.aviso = data));

      fetch(
        "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
        {
          method: "post",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            filter: { activo: true },
            sort: { _o: 1 },
            lang: "de", // return normalized language fields (fieldA_de => fieldA)
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => (this.servicios = res.entries));
    }

    var aux = this;

    setTimeout(() => {
      aux.cookieConsent = true;
    }, 4000);
  },
  methods: {
    handleLanguage(lang) {
      this.$i18n.locale = lang;
    },
    registrarCookie: function (){
      this.$session.set('dontShownn',true);
    },
    subscribeAction: function (){
    }
  },
  watch: {
    $route(to, from) {
      to;
      from;
      this.isOpen = false;
    },
    locale: function () {
      if (this.locale == "en") {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/AvisoPrivacidad?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: { activo: true },
              sort: { _o: 1 },
              lang: "en", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.aviso = data));

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: { activo: true },
              sort: { _o: 1 },
              lang: "en", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.servicios = res.entries));
      } else {
        fetch(
          "https://nncms.actstudio.xyz/api/singletons/get/AvisoPrivacidad?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: { activo: true },
              sort: { _o: 1 },
              lang: "de", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((data) => data.json())
          .then((data) => (this.aviso = data));

        fetch(
          "https://nncms.actstudio.xyz/api/collections/get/Servicios?token=8cf7ca41761951fdde0c1e2cfda401",
          {
            method: "post",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              filter: { activo: true },
              sort: { _o: 1 },
              lang: "de", // return normalized language fields (fieldA_de => fieldA)
            }),
          }
        )
          .then((res) => res.json())
          .then((res) => (this.servicios = res.entries));
      }
    },
  },
  computed: {
    locale: function () {
      return this.$i18n.locale;
    },
    showCookieConsent: function () {
      return !this.$session.has('dontShownn')
    }
  },
};
</script>
